var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"information-box__link",attrs:{"target":_vm.target,"to":_vm.href}},[_c('icon',{staticClass:"information-box__link-icon",attrs:{"link":"","type":"angle-right"}}),_vm._v(" "),_c('span',{staticClass:"information-box__link-text"},[_vm._t("link")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8355073e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AfLink.vue
// module id = 669
// module chunks = 1